/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { mcpRegistriesGetSetupDocs } from "../funcs/mcpRegistriesGetSetupDocs.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetSetupDocsResponseBody } from "../models/components/getsetupdocsresponsebody.js";
import {
  GetMCPSetupDocsRequest,
  GetMCPSetupDocsSecurity,
} from "../models/operations/getmcpsetupdocs.js";
import { unwrapAsync } from "../types/fp.js";
export type GetMCPSetupDocsQueryData = GetSetupDocsResponseBody;

export function prefetchGetMCPSetupDocs(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetMCPSetupDocsRequest | undefined,
  security?: GetMCPSetupDocsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetMCPSetupDocsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetMCPSetupDocsQuery(
  client$: GramCore,
  request?: GetMCPSetupDocsRequest | undefined,
  security?: GetMCPSetupDocsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<GetMCPSetupDocsQueryData>;
} {
  return {
    queryKey: queryKeyGetMCPSetupDocs({
      serverUrl: request?.serverUrl,
      registrySpecifier: request?.registrySpecifier,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function getMCPSetupDocsQueryFn(
      ctx,
    ): Promise<GetMCPSetupDocsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(mcpRegistriesGetSetupDocs(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetMCPSetupDocs(
  parameters: {
    serverUrl?: string | undefined;
    registrySpecifier?: string | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "mcpRegistries", "getSetupDocs", parameters];
}
